var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"actions":_vm.modalActions,"title":"JOIN_SCHOOL"},on:{"submit":_vm.submit,"close":_vm.close}},[_c('EditSection',{ref:"mainSections",attrs:{"errors":_vm.errors,"sections":_vm.joinSections}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }